// Script de prueba para verificar el funcionamiento del registro de choferes
import { ChoferesService } from '../services/choferesService';

export const testChoferRegistration = async () => {
  console.log('=== PRUEBA DE REGISTRO DE CHOFERES ===');
  
  try {
    // Datos de prueba
    const choferPrueba = {
      nombre: 'Juan',
      apellido: 'Pérez',
      edad: 30,
      numeroTelefono: '1234567890',
      domicilio: 'Calle Principal 123',
      tipoLicencia: 'B',
      estado: 'activo'
    };
    
    console.log('1. Creando chofer de prueba...', choferPrueba);
    
    // Crear chofer
    const choferId = await ChoferesService.crearChofer(choferPrueba);
    console.log('2. Chofer creado con ID:', choferId);
    
    // Obtener choferes
    console.log('3. Obteniendo lista de choferes...');
    const choferes = await ChoferesService.obtenerChoferes();
    console.log('4. Choferes encontrados:', choferes.length);
    console.log('5. Lista de choferes:', choferes);
    
    // Verificar que el chofer se guardó
    const choferEncontrado = choferes.find(c => c.id === choferId);
    if (choferEncontrado) {
      console.log('✅ ÉXITO: El chofer se guardó correctamente');
      console.log('Datos del chofer guardado:', choferEncontrado);
    } else {
      console.log('❌ ERROR: El chofer no se encontró en la lista');
    }
    
    return { success: true, choferId, totalChoferes: choferes.length };
    
  } catch (error) {
    console.error('❌ ERROR en la prueba:', error);
    return { success: false, error: error.message };
  }
};

// Función para limpiar datos de prueba
export const limpiarDatosPrueba = () => {
  try {
    localStorage.removeItem('choferes_backup');
    console.log('Datos de prueba limpiados');
  } catch (error) {
    console.error('Error al limpiar datos de prueba:', error);
  }
};







